export default class clientesService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/proyectos',
			"id": '/api/proyectos/:id',
            "list_all": '/api/proyectos/list/all',
			"cliente": '/api/proyectos/cliente',
			"new": '/api/proyectos',
			"delete": "/api/proyectos/:id",
			"update": "/api/proyectos"
		};
	}

	getAll(filters){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params:{}
		};
		if (typeof filter == 'string') {
			config.params = {
				string: filters
			}
		}else{
			config.params = filters;
		}
		return this.http.get(url, config);
	}

	getByCliente(filters){
		let url = this.baseUrl + this.routes.cliente;
		let config = {}
		if (filters !== undefined) {
			config.params = filters
		}
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

    update(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }

    getAllList(filters){
        let url = this.baseUrl + this.routes.list_all;
        let config = {
            params : filters
        };
        return this.http.get(url, config);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/proyectosService.js